var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 69.375,
    height: 60,
    rx: 30,
    fill: "#02B740"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.704 45.606c-.079.009-.165.001-.236.029-.468.185-.94.173-1.406.014-4.438-1.509-8.184-4.04-11.214-7.623a23.993 23.993 0 0 1-3.042-4.52c-2.522-4.906-3.408-10.092-2.557-15.553.142-.911.35-1.814.577-2.708.282-1.11 1.404-1.813 2.515-1.513 1.692.459 3.371.97 5.036 1.516 1.097.36 1.603 1.366 1.403 2.507a87.46 87.46 0 0 0-.496 3.183c-.052.38-.021.77-.031 1.155-.022.892-.397 1.562-1.205 1.983-1.1.573-2.185 1.174-3.285 1.743-.274.141-.324.293-.243.58.676 2.366 1.777 4.544 3.02 6.646.674 1.14 1.514 2.18 2.273 3.269.198.284.388.346.718.16 1.06-.596 2.142-1.15 3.213-1.729.772-.417 1.54-.39 2.258.083a19.808 19.808 0 0 0 3.867 1.965c1.187.454 1.71 1.572 1.349 2.794-.45 1.525-.923 3.043-1.386 4.565-.15.494-.392.922-.842 1.209-.065.042-.109.118-.163.178l-.123.067Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-118.126 30.237 19.054)",
    d: "M0 0h36v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.d3aebd98311666e8b02b41503c97537e.svg";
export { ForwardRef as ReactComponent };